<template>
  <input :type="type" 
    @input="$emit('input', $event.target.value)"
    ref="input" />
</template>
<script>
export default {
  props: ["type"],
   mounted(){
    this.$refs.input.focus();
   }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_mixins.scss';

  input {
    background-color: lighten( map-get($colors--grays, '2'), 5% );
    
    @include respond-to(desktop) {
      border-radius: 0;
      text-align: left;
      border: none;
      border-bottom: 2px solid $gray_dark_2;
    }
  }
</style>